module.exports = __webpack_public_path__ + "385d5d27ca3029a42f7ed85c7dbecf12.fbx";